import store from '../store';
const methods = {
  goTo(value, share) {
    if (value.path == '/login' || value.name == 'login') {
      this.$router
        .push({
          path: value.path,
          name: value.name,
          params: value.params,
          query: value.query,
          hash: value.hash,
        })
        .catch(() => {});

      return;
    }
    if (store.getters.lan == 'en' && share == undefined) {
      this.$router
        .push({
          path: this.lan + '/' + value.path,
          name: this.lan + '-' + value.name,
          params: value.params,
          query: value.query,
          hash: value.hash,
        })
        .catch(() => {});
      return;
    }
    this.$router
      .push({
        path: value.path,
        name: value.name,
        params: value.params,
        query: value.query,
        hash: value.hash,
      })
      .catch(() => {});
  },
};

export default {
  install(Vue) {
    Vue.prototype.$_goTo = methods.goTo;
  },
  data() {
    return {
      language: '',
    };
  },
  computed: {},
};
